export const APP_NAME = "Calculadora laboral";
export const COMPANY_NAME = "LegalFlow, S.A. de C.V.";
export const COMPANY_ADDRESS =
  "Yácatas número 215, colonia Narvarte Poniente, alcaldía Benito Juárez, C.P. 03020, Ciudad de México";
export const COMPANY_PHONE = "(56) 2424 0001";
export const PRIVACY_NOTICE_VERSION = "2026-07-28";
export const COMPANY_SITE = "https://www.legalflow.solutions/";

export const awsConfig = {
  region: import.meta.env.VITE_AWS_REGION || "us-east-1",
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || "",
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || "",
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || "",
  apiUrl: (import.meta.env.VITE_API_URL || "").replace(/\/$/, ""),
};

export const cloudFeaturesEnabled = Boolean(
  awsConfig.userPoolId &&
    awsConfig.clientId &&
    awsConfig.cognitoDomain &&
    awsConfig.apiUrl,
);
